/* eslint-disable @next/next/no-img-element */
import parse from "react-html-parser"
import { observer } from "mobx-react"
import { useStore } from "@features/common"

import MissionSectionIllustration from "./mission-section-illustration.png"

const Mission = () => {
  const {
    TeamPageModel: { getTemplate },
  } = useStore()

  const title =
    getTemplate("about.mission.title", false) ||
    'OUR <span class="text-red-300 line-through">MISSION</span><br/>WILD IDEA'
  const description =
    getTemplate("about.mission.description", false) ||
    'Pure is a dating app that’s all about connection, chemistry, and curiosity. <span class="font-serif-italic">A safe space where knowing what you want is magnetic, and owning it is powerful.</span> We believe your desires should be celebrated, not hidden.'

  return (
    <section className="w-full mb-[120px] tablet:mb-[158px] desktop:pl-[50px] pl-0 pr-[10px]">
      <div className="relative max-w-screen-desktop-l w-full h-full mx-auto flex laptop:gap-[50px] justify-center items-center flex-col laptop:flex-row">
        <img
          src={MissionSectionIllustration.src}
          alt="Illustration"
          className="relative top-0 left-[-30px] w-[400px] max-w-none mobile-xl:w-[420px] tablet:w-[520px] laptop:w-[656px] h-auto pointer-events-none select-none"
        />
        <div className="ml-[37px] tablet:ml-0 w-auto tablet:w-[550px] h-auto">
          <div className="w-fit mb-[55px] tablet:mb-[80px] font-pure rotate-[-6.45deg] leading-[48px] tablet:leading-[64px] text-[36px] tablet:text-[64px]">
            {parse(title)}
          </div>
          <div className="w-[82%] tablet:ml-[30px] font-sans text-[16px] tablet:text-[20px] leading-[20px] tablet:leading-[32px] rotate-[2.507deg]">
            {parse(description)}
          </div>
        </div>
      </div>
    </section>
  )
}

const MissionComponent = observer(Mission)

export { MissionComponent }
